import * as Yup from 'yup';

export const demandsDetailValidationSchema = (noDemandItemIds: number[]) =>
    Yup.object().shape({
        demandAccountItems: Yup.array().of(
            Yup.object().shape({
                demandItemId: Yup.number().required(), // Ensures demandItemId is present
                deliveryAddress: Yup.object()
                    .typeError('app.error.required')
                    .when('demandItemId', {
                        is: (demandItemId: number) => !noDemandItemIds.includes(demandItemId),
                        then: schema => schema.required('app.error.required'),
                        otherwise: schema => schema.nullable(),
                    }),
                quantity: Yup.number()
                    .typeError('app.error.required')
                    .when('demandItemId', {
                        is: (demandItemId: number) => !noDemandItemIds.includes(demandItemId),
                        then: schema => schema.required('app.error.required').moreThan(0, 'app.error.greaterZero'),
                        otherwise: schema => schema.nullable(),
                    }),
                costCentre: Yup.string().nullable(),
            })
        ),
    });
